import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { HookSection } from '../components/sales/HookSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { RevelationSection } from '../components/sales/RevelationSection';
import { ProductSection } from '../components/sales/ProductSection';
import { ForWhomSection } from '../components/sales/ForWhomSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { AuthorSection } from '../components/sales/AuthorSection';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FAQSection } from '../components/sales/FAQSection';
import { CloseSection } from '../components/sales/CloseSection';
import { SalesNotification } from '../components/sales/SalesNotification';
export function SalesPage() {
  return <main className="w-full" style={{
    background: 'var(--cream)'
  }} data-id="element-545">
      <HeroSection data-id="element-546" />
      <HookSection data-id="element-547" />
      <ProblemSection data-id="element-548" />
      <RevelationSection data-id="element-549" />
      <ProductSection data-id="element-550" />
      <ForWhomSection data-id="element-551" />
      <TestimonialsSection data-id="element-552" />
      <AuthorSection data-id="element-553" />
      <GuaranteeSection data-id="element-554" />
      <OfferSection data-id="element-555" />
      <FAQSection data-id="element-556" />
      <CloseSection data-id="element-557" />
      <SalesNotification data-id="element-558" />
    </main>;
}